import React, { useState, InputHTMLAttributes } from 'react';
import styles from '../css/CustomPasswordInput.module.scss';
import { useTranslation } from 'react-i18next';

interface CustomPasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: string;
  error?: string;
}

const CustomPasswordInput = (props: CustomPasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <img src={showPassword ? '/assets/images/eye-line.svg' : '/assets/images/eye-off-line.svg'} alt={t('customPasswordInput.alt')} className={styles.toggleIcon} onClick={() => setShowPassword((prev) => !prev)} />
      <input {...props} type={showPassword ? 'text' : 'password'} className={`${styles.input} ${props.icon ? styles.withIcon : ''} ${props.error ? styles.error : ''} ${props.disabled ? styles.disabled : ''}`} autoComplete="off" />
    </div>
  );
};

export default CustomPasswordInput;
